// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__QBZOi","slide-down":"Notification_slide-down__+xKap","success":"Notification_success__0JESz","error":"Notification_error__ReaLY"};